import { render } from "./Footer.vue?vue&type=template&id=3315be5e&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3315be5e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3315be5e"]])

export default __exports__